import React from 'react'
import Modal from 'react-modal'
import modalStyle from '../../../_common/core/modalStyle'
import CustomerFormForm from './CustomerFormForm'

const CustomerFormModal = props => {
  const { eventId, isModalOpen, closeModal, selectedFormData, handleSubmit, emailTemplatesOption } = props

  return (
    <Modal
      className="modal-dialog modal-trans customer-form-modal"
      isOpen={isModalOpen}
      // onRequestClose={closeModal}
      style={modalStyle}
      contentLabel="Create Custom Form"
      overlayRef={ref => {
        if (ref) {
          ref.setAttribute('id', 'customer_form_modal')
        }
      }}
      ariaHideApp={false}
    >
      <div className="modal-dialog" style={{ overflow: 'visible' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h2>{Boolean(selectedFormData) ? 'Edit Form' : 'Create Form'}</h2>
          </div>
          <div className="modal-body">
            <CustomerFormForm
              eventId={eventId}
              closeModal={closeModal}
              selectedFormData={selectedFormData}
              handleSubmitForm={handleSubmit}
              emailTemplatesOption={emailTemplatesOption}
              containerId="customer_form_modal"
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CustomerFormModal
